import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Términos de Servicio
        </Typography>
        <Typography variant="body1" paragraph>
          Al usar Jooru, aceptas cumplir con estos términos de servicio.
        </Typography>
        <Typography variant="body1">
          Por favor, lee cuidadosamente estos términos antes de usar nuestra plataforma.
        </Typography>
      </Box>
    </Container>
  );
};

export default Terms;